/**
 * @file: constants.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const kMaxZoomFactor = 20;
export const kScaleFullZoom = 3;

// minimum duration (ms) for video recording
export const kDefaultRecordingMinDuration = 1000;
